import React from 'react';
import Div from '../Div';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import Newsletter from '../Widget/Newsletter';
import SocialWidget from '../Widget/SocialWidget';
import TextWidget from '../Widget/TextWidget';
import './footer.scss';
const copyrightLinks = [
  {
    title: 'Terms of Use',
    href: '/',
  },
  {
    title: 'Privacy Policy',
    href: '/',
  },
];

const serviceMenu = [
  { title: 'Home', href: '/' },
  { title: 'Projects', href: '/projects' },
  { title: 'About', href: '/about' },
  { title: 'Contact', href: '/contact' },
];

const serviceMenu2 = [
  {
    title: 'DApp Development',
    href: '/service/dapp-development',
  },
  {
    title: 'Smart Contract Development',
    href: '/service/smart-contract',
  },
  {
    title: 'Web & Mobile App Development',
    href: '/service/web-mobile-development',
  },
  {
    title: 'Telegram & Bot Apps Development',
    href: '/service/telegram-bot-apps-development',
  },
  {
    title: 'Game Development',
    href: '/service/game-developemnt', // confirm if "developemnt" is intended or a typo
  },
  {
    title: 'AR (Augmented Reality) Development',
    href: '/service/augmented-reality-development',
  },
  {
    title: 'VR (Virtual Reality) Development',
    href: '/service/virtual-reality-development',
  },
  {
    title: 'UI/UX Designing',
    href: '/service/ui-ux-designing',
  },
  {
    title: '3D Asset Creation',
    href: '/service/3d-assets-creation',
  },
];

export default function Footer({ copyrightText, logoSrc, logoAlt, text }) {
  return (
    <footer className="cs-fooer">
      <Div className="cs-fooer_main">
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <TextWidget
                  logoSrc="/images/dappster-logo-updated.png"
                  logoAlt="Logo"
                  width={150} // Set your desired width
                  height={50} // Set your desired height
                  text="Welcome to DAppster Studio, where innovation meets creativity."
                />
                <SocialWidget />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu2} menuHeading="Services" />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu} menuHeading="Quick Links" />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <ContactInfoWidget title="Contact Us" />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright"> Copyright © {new Date().getFullYear()} Dappster</Div>
          </Div>
          <Div className="cs-bottom_footer_right">
            <MenuWidget menuItems={copyrightLinks} variant=" cs-style2" />
          </Div>
        </Div>
      </Div>
    </footer>
  );
}
